// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"_772e1b1e50--checkbox--oMeNF","box":"_772e1b1e50--box--aD_nX","label":"_772e1b1e50--label--iT_qr"};